import type { FunctionComponent, ReactNode } from 'react';
import styled from 'styled-components';
import PureReactCarouselStyles from '!!raw-loader!pure-react-carousel/dist/react-carousel.es.css';
import '../../raw-loader.d';
import { MediaGalleryCarouselContents } from './MediaGalleryCarouselContents';
import { useMediaGalleryKeyboard } from './hooks/useMediaGalleryKeyboard';

const MediaGalleryCarouselWrapper = styled.div`
  ${PureReactCarouselStyles};
  position: relative;
  display: flex;
  align-items: center;
  height: 100%;
  flex-direction: column;
  justify-content: center;
`;

interface MediaGalleryCarouselProps {
  Timeline?: ReactNode;
}

export const MediaGalleryCarousel: FunctionComponent<MediaGalleryCarouselProps> = ({
  Timeline,
}) => {
  useMediaGalleryKeyboard();

  return (
    <MediaGalleryCarouselWrapper>
      {Timeline}
      <MediaGalleryCarouselContents />
    </MediaGalleryCarouselWrapper>
  );
};
